import { Collection, WhereField } from '../../shared/constants';
import { addDoc, deleteDoc, getAllDocsByQueries, updateDoc } from './collectionBaseWorker';
import { where } from "firebase/firestore";

export const getAllSupportCentersByRessales = async ({ associatedResales }) => {
    return await getAllDocsByQueries({
        collection: Collection.SUPPORT_CENTER,
        queries: [
            where(WhereField.REVENDAID, "in", associatedResales.map(e => e.value))
        ]
    })
}

export const addSupportCenter = async ({ data }) => {
    await addDoc({ collection: Collection.SUPPORT_CENTER, data: data })
}

export const updateSupportCenterById = async ({ id, data }) => {
    await updateDoc({ collection: Collection.SUPPORT_CENTER, id: id, data: data })
}

export const removeSupportCenterById = async ({ id }) => {
    await deleteDoc({ collection: Collection.SUPPORT_CENTER, id: id })
}